import { useContext } from 'react';

import { PatientContext } from './context';

const usePatient = () => useContext(PatientContext);

export default usePatient;
